
export default {
    computed: {
        getFilterStaticData () {
            const getterName = `Reports${this.tab}/getFilterStaticData`
            return this.$store.getters[getterName]
        },
        filtersWithFacets () {
            const getterName = `Reports${this.tab}/filtersWithFacets`
            return this.$store.getters[getterName]
        },
        filtersWithKey () {
            const getterName = `Reports${this.tab}/filterWithKey`
            return this.$store.getters[getterName]
        },
        hideUncompletedCourses () {
            const getterName = `Reports${this.tab}/getToggleHideUncompletedCourses`
            return this.$store.getters[getterName]
        },
        hideCompletedCourses () {
            const getterName = `Reports${this.tab}/getToggleHideCompletedCourses`
            return this.$store.getters[getterName]
        },
        searchQuery () {
            const getterName = `Reports${this.tab}/searchQuery`
            return this.$store.getters[getterName]
        },
        isThereActiveFilters () {
            const getterName = `Reports${this.tab}/isThereAnyActiveFilter`
            return this.$store.getters[getterName]
        },
        getClearFilterRoute () {
            return `Reports${this.tab}/clearFilter`
        },
        getClearAllFilters () {
            return `Reports${this.tab}/clearAllFilters`
        },
        getAddFilterValueRoute () {
            return `Reports${this.tab}/addFilterValue`
        },
        getSetFilterValuesRoute () {
            return `Reports${this.tab}/setFilterValues`
        },
        getRemoveFilterRoute () {
            return `Reports${this.tab}/removeFilterValue`
        },
        getSetQueryRoute () {
            return `Reports${this.tab}/setQuery`
        },
        getToggleUncompletedCoursesRoute () {
            return `Reports${this.tab}/toggleHideUncompletedCourses`
        },
        getToggleCompletedCoursesRoute () {
            return `Reports${this.tab}/toggleHideCompletedCourses`
        },
        categoriesIntoTreeModel () {
            const getterName = `Reports${this.tab}/getFilteredCategories`
            return this.$store.getters[getterName]
        },
        getLoadCategoriesRoute () {
            return `Reports${this.tab}/loadCategories`
        },
        filters () {
            const getterName = `Reports${this.tab}/filters`
            return this.$store.getters[getterName]
        }
    }
}
